import PreloaderScreen from './PreloaderScreen';
export default PreloaderScreen;